import Image from 'next/image';
import Link from 'next/link';

const ServiceCard = ({ imageSrc, title, description, link, height }) => {

  const isTall = height === "h-[467px]";
  const sizes = `(max-width: 768px) 100vw, (max-width: 1024px) 50vw, ${isTall ? '358px' : '255px'}`;

  return (
    <div className={`service-card group relative overflow-hidden w-full h-[467px] ${height === "h-[467px]" ? "lg:h-[467px]" : "lg:h-[338px]"}`} onClick={() => (window.location.href = link)}>
      <Image
        src={imageSrc}
        alt={title}
        title={title}
        width={isTall ? 358 : 255}
        height={isTall ? 467 : 340}
        className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500 ease-in-out"
        sizes={`(max-width: 768px) 100vw, (max-width: 1024px) ${isTall ? '50vw' : '533w'}, ${isTall ? '358px' : '255px'}`}
        quality={60}
      />
      <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-70 transition-all duration-500 ease-in-out flex flex-col justify-end p-4">
        <div className="relative pb-2 flex flex-col items-start group">
          <h2 className="text-white uppercase tracking-wide text-2xl mb-2 transform group-hover:-translate-y-4 transition-all duration-500 ease-in-out">
            {title}
          </h2>
          <span className="block h-[1px] bg-opacity-30 w-20 bg-white transform group-hover:w-full group-hover:-translate-y-4 transition-all duration-500 ease"></span>
        </div>
        <p className="text-white text-md mb-8 transform group-hover:-translate-y-4 transition-all duration-500 ease-in-out">
          {description}
        </p>
        <Link
          href={link}
          className="text-white text-md uppercase tracking-wider absolute bottom-4 right-4 hover:text-primary"
        >
          Details <span className="ml-2">→</span>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
